export const projects = [
  {
    id: 1,
    slug: 'chargenest',
    title: 'ChargeNest',
    status: 'Live',
    role: 'Gründer & Betreiber',
    category: 'Hardware & Plattform',
    website: 'https://chargenest.de',
    summary:
      'Powerbank-Vermietstationen mit eigener Hardware-Infrastruktur und digitaler Plattform für nahtloses Ausleihen.',
    description:
      'ChargeNest verbindet physische Powerbank-Stationen mit einer digitalen Plattform. Nutzer können unterwegs unkompliziert eine Powerbank ausleihen und an einer teilnehmenden Station zurückgeben.',
    services: [
      'Konzeption des Geschäftsmodells',
      'Aufbau der Hardware-Infrastruktur',
      'Entwicklung der digitalen Plattform',
      'Betrieb und Weiterentwicklung'
    ],
    technologies: ['IoT', 'Webplattform', 'Zahlungssysteme', 'Hardware'],
    accent: 'from-emerald-500/25 via-emerald-500/5 to-transparent'
  },
  {
    id: 2,
    slug: 'donabox',
    title: 'Donabox',
    status: 'Live',
    role: 'Gründer & Entwickler',
    category: 'FinTech & Hardware',
    website: 'https://donabox.de',
    summary:
      'Hardware- und Softwarelösung für digitale Spendensammlungen mit direkter Weiterleitung der Spenden.',
    description:
      'Donabox ermöglicht digitale Spenden über moderne Stationen. Gemeinden und Organisationen erhalten die Spenden direkt, während die Finanzierung des Systems ausschließlich über die Nutzung der zugehörigen Anwendung erfolgt.',
    services: [
      'Produkt- und Hardwarekonzeption',
      'Entwicklung der Softwarelösung',
      'Nutzerfreundlicher Spendenprozess',
      'Betrieb und Weiterentwicklung'
    ],
    technologies: ['App-Entwicklung', 'Hardware', 'Payment', 'Cloud'],
    accent: 'from-blue-500/25 via-blue-500/5 to-transparent'
  },
  {
    id: 3,
    slug: 'zutatenlupe',
    title: 'Zutatenlupe',
    status: 'Live bei Google Play',
    role: 'App-Entwicklung',
    category: 'Mobile Anwendung',
    website: 'https://zutatenlupe.com',
    storeLinks: [
      {
        label: 'Google Play',
        url: 'https://play.google.com/store/apps/details?id=com.zutatenlupe.app'
      }
    ],
    storeNote: 'Der Apple App Store folgt demnächst.',
    summary:
      'Mobile App zur schnellen und verständlichen Analyse von Inhaltsstoffen in Lebensmitteln.',
    description:
      'Zutatenlupe macht komplexe Zutatenlisten verständlich. Die App unterstützt Nutzer dabei, Inhaltsstoffe schnell zu erfassen und informierte Entscheidungen beim Lebensmitteleinkauf zu treffen. Sie ist bereits bei Google Play verfügbar, der Apple App Store folgt demnächst.',
    services: [
      'Konzeption der Nutzerführung',
      'Entwicklung der mobilen Anwendung',
      'Aufbereitung komplexer Produktdaten',
      'Veröffentlichung bei Google Play, App Store folgt'
    ],
    technologies: ['iOS', 'Android', 'Mobile UX', 'Produktanalyse'],
    accent: 'from-amber-500/25 via-amber-500/5 to-transparent'
  },
  {
    id: 4,
    slug: 'pv-netzplaner',
    title: 'PV-Netzplaner',
    status: 'Beta',
    role: 'Web-Entwicklung',
    category: 'Planungssoftware',
    website: 'https://pv-netzplaner.de',
    summary:
      'Digitales Planungstool für Photovoltaikanlagen mit effizientem und übersichtlichem Arbeitsablauf.',
    description:
      'Der PV-Netzplaner unterstützt die strukturierte Planung von Photovoltaikanlagen. Die Webanwendung bündelt relevante Planungsschritte in einer klaren Oberfläche und ist aktuell als Beta-Version veröffentlicht.',
    services: [
      'Konzeption der Webanwendung',
      'Entwicklung des Planungstools',
      'Optimierung der Bedienoberfläche',
      'Integration von Zahlungsoptionen'
    ],
    technologies: ['React', 'Webanwendung', 'Photovoltaik', 'Payment'],
    accent: 'from-yellow-500/25 via-yellow-500/5 to-transparent'
  },
  {
    id: 5,
    slug: 'ki-telefonassistenten',
    title: 'KI-Telefonassistenten',
    status: 'Dienstleistung',
    role: 'KI-Integration',
    category: 'Künstliche Intelligenz',
    summary:
      'Intelligente Telefonassistenten für automatisierten Kundenservice und eine bessere Erreichbarkeit.',
    description:
      'Individuell entwickelte KI-Telefonassistenten übernehmen wiederkehrende Gespräche, beantworten häufige Fragen und unterstützen Unternehmen bei der zuverlässigen Bearbeitung eingehender Anrufe.',
    services: [
      'Analyse bestehender Telefonprozesse',
      'Konzeption individueller Gesprächsabläufe',
      'Integration in bestehende Systeme',
      'Optimierung und laufende Betreuung'
    ],
    technologies: ['Sprach-KI', 'Automatisierung', 'API-Integration', 'Telefonie'],
    accent: 'from-violet-500/25 via-violet-500/5 to-transparent'
  },
  {
    id: 6,
    slug: 'elektro-solar-webentwicklung',
    title: 'Elektro, Solar & Webentwicklung',
    status: 'Dienstleistung',
    role: 'Ganzheitlicher Service',
    category: 'Technische Dienstleistungen',
    summary:
      'Ganzheitliche Lösungen von Elektro- und Solartechnik bis zu individuellen Webseiten und Apps.',
    description:
      'Technische Projekte werden ganzheitlich umgesetzt: von der physischen Elektro- und Solarinfrastruktur bis zur passenden digitalen Lösung. So entstehen abgestimmte Systeme aus einer Hand.',
    services: [
      'Fachgerechte Elektroarbeiten',
      'Installation von Solaranlagen',
      'Entwicklung individueller Webseiten',
      'Umsetzung maßgeschneiderter Apps'
    ],
    technologies: ['Elektrotechnik', 'Photovoltaik', 'Webentwicklung', 'Apps'],
    accent: 'from-cyan-500/25 via-cyan-500/5 to-transparent'
  }
];

export const getProjectBySlug = (slug) =>
  projects.find((project) => project.slug === slug);
